<template>
<div>
    <h1>{{ $t("myProfileView.title") }}</h1>
    <p>{{ $t("myProfileView.choosePictureAndText") }}</p>
    <h2>{{ $t("myProfileView.myProfilePicture") }}</h2>
    <div class="profile-picture-chooser">
        <input type="file" id="fileinput" class="profile-picture" @change="profilePictureSelected" accept=".jpg,.jpeg,.png" />
        <label for="fileinput">
            <div v-if="!store.currentUser.profilePicture">
                <div class="profile-picture-circle">
                    <span class="icon icon-grin file-input-img"></span>
                </div>
            </div>
            <div v-else>
                <img :src="'data:image/jpg;base64,' + this.profilePicture" width="150" />
            </div>
        </label>
        <div v-if="invalidImageSelected">{{ $t("myProfileView.allowedImageTypes") }}</div>
    </div>

    <div>
        <label for="slogan"><h2>{{ $t("myProfileView.slogan") }}</h2></label>
        <textarea id="slogan" rows=2 v-model="user.slogan" :placeholder="$t('myProfileView.slogan')" />
    </div>

    <h2>{{ $t("myProfileView.language") }}</h2>
    <div class="radio-content">
        <label v-for="l in locales" :key="l">
            <input type="radio" name="locale" :id="l" :value="l" @click="setLocale(l)" :checked="store.currentUser.locale == l"/>
            <span class="label-text">{{ $t(`myProfileView.locale_${l}`) }}</span>
            <span class="checkmark icon-checkmark"></span>
        </label>
    </div>

    <p class="button-container">
        <button class="button button-green" @click="save">{{ $t("myProfileView.saveChanges") }}</button>
        <button class="button" @click="instructions">{{ $t("myProfileView.instructions") }}</button>
        <button class="button" @click="privacySettings">{{ $t("myProfileView.privacySettings") }}</button>
        <button class="button button-primary" @click="logout">{{ $t("myProfileView.logout") }}</button>

        <p class="saved-notification" :class="{ 'fadeout': changesSaved }">
            {{ $t("myProfileView.changesSaved") }}
        </p>
    </p>
</div>
</template>

<script lang="ts">
import { User, store } from "store";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
    async mounted() {
        this.setTitle();
        this.profilePicture = (await axios.get("users/me/profile-picture")).data;
    },
    data() {
        const user: User = store.currentUser;

        return {
            store: store,
            locales: [ "fi", "se" ],
            user,
            changesSaved: false,
            profilePictureUploading: false,
            error: "",
            invalidImageSelected: false,
            profilePicture: null
        };
    },
    methods: {
        async profilePictureSelected(e) {
            let file = e.target.files[0];
            if (!file) {
                return;
            }

            let formData = new FormData();
            formData.append("file", file);

            const allowedImageTypes = [
                "image/png", "image/jpeg",
            ];
            if (!allowedImageTypes.some(type => type == file.type)) {
                this.invalidImageSelected = true;
                return;
            }

            try {
                this.invalidImageSelected = false;
                this.profilePictureUploading = true;
                this.user.profilePicture = (await axios.post(
                    'users/me/profile-picture',
                     formData,
                     { headers: { "Content-Type": "multipart/form-data" } }
                )).data;

                this.profilePicture = (await axios.get("users/me/profile-picture")).data;
                this.profilePictureUploading = false;
            } catch(e) {
                // TODO: Handle error
            }
        },
        setTitle() {
            store.page.title = this.$t("myProfileView.title") as string;
            store.page.showTopNav = true;
        },
        async save() {
            try {
                this.changesSaved = false;
                await axios.put(`users/${store.currentUser.userId}`, this.user);
                this.changesSaved = true;
            } catch(e) {
                console.log(e.message);
                // TODO: Handle error
            }
        },
        async setLocale(locale: string) {
            this.$i18n.locale = locale;
            store.currentUser.locale = locale;
            await axios.put(`users/${store.currentUser.userId}`, store.currentUser);
        },
        instructions() {
            this.$router.push("/mobile-app-instructions");
        },
        privacySettings() {
            this.$router.push("/privacy-settings");
        },
        logout() {
            localStorage.removeItem("accessToken");
            location.reload();
        }
    }
})

</script>